import { Component } from '@angular/core';
import { TabName } from '@enum';
import { TabData } from '@interfaces';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrl: './reports.component.scss',
})
export class ReportsComponent {
  tabNames = TabName;

  tabs: TabData[] = [
    {
      name: this.tabNames.SURVEYS,
      label: 'Encuestas',
    },
    { name: this.tabNames.STAR_CLIENT, label: 'Clientes estrella' },
  ];

  activeTab: string = this.tabNames.SURVEYS;
  constructor() {}

  ngOnInit() {}

  onTabChange(selectedTab: string): void {
    this.activeTab = selectedTab;
  }
}
